<h2 mat-dialog-title>Allow National Access?</h2>

<mat-dialog-content>
  <p>
    This will give {{ data.userName }} access to every state and territory.
  </p>
  <p>Any pending state-access requests for this user will be removed.</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button [mat-dialog-close]="false" cdkFocusInitial>
    Cancel
  </button>
  <button mat-flat-button color="primary" [mat-dialog-close]="true">
    Allow National Access
  </button>
</mat-dialog-actions>
